import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-generate-payment',
  templateUrl: './generate-payment.component.html',
  styleUrls: ['./generate-payment.component.scss'],
})
export class GeneratePaymentComponent implements OnInit {
  loading = true;
  error = false;

  constructor(private route: ActivatedRoute, private surveyService: SurveyService) {}

  ngOnInit(): void {
    const utilityGuid = this.route.snapshot.paramMap.get('utilityGuid') || '';
    const surveyGuid = this.route.snapshot.paramMap.get('surveyGuid') || '';

    this.surveyService.generatePaymentUrl(surveyGuid, utilityGuid).subscribe({
      next: (response: any) => {
        if (response?.data) {
          window.location.href = response.data;
        } else {
          this.loading = false;
          this.error = true;
        }
      },
      error: () => {
        this.loading = false;
        this.error = true;
      },
    });
  }
}
